<template>
    <div class="bottsfixed">
        © 2021 All Rights Reserved 苏州量子方舟网络科技有限公司 版权所有 <span class="bottomSpans">
                     <a href="https://beian.miit.gov.cn/" style="">苏ICP备18053448号-2</a>
                </span>
    </div>

</template>

<script>
    export default {
    name: "botts",
    data(){
        return{
        
        }
    },
    mounted(){},
    methods:{
        
    },
}
</script>

<style scoped lang='scss'>
.bottsfixed{
    width: 100%;
    height: 0.6rem;
    background: #fff;
    box-shadow: 0px -1px 8px 2px rgba(187,186,186,0.75);
    -webkit-box-shadow: 0px -1px 8px 2px rgba(187,186,186,0.75);
    -moz-box-shadow: 0px -1px 8px 2px rgba(187,186,186,0.75);
    color: #666;
    text-align: center;
    line-height: 0.6rem;
    position: fixed;
    bottom: 0;
    .bottomSpans {
        cursor: pointer;

        a {
            text-decoration: none;
        }

        color: #666;

        a:visited, a:link, a:active {
            color: #666;
        }

        a:hover {
            color: blue;
        }
    }
}
</style>